const books = [
  {
    author: "Дэн Браун",
    books: [
      {
        id: "1",
        article: "1",
        title: "Инферно",
        description:
          "Оказавшись в самом загадочном городе Италии – Флоренции, профессор Лэнгдон, специалист по кодам, символам и истории искусства, неожиданно попадает в водоворот событий, которые способны привести к гибели все человечество… И помешать этому может только разгадка тайны, некогда зашифрованной Данте в...",
        age: "16+",
        genre: "История, секреты",
        author: "Дэн Браун",
        img: "/images/books/Инферно.jpg",
        price: 515,
      },
      {
        id: "2",
        article: "2",
        title: "Утраченный символ",
        description:
          "«Утраченный символ» — это роман культового писателя Дэна Брауна, мастера запутанных детективных историй, переплетающих в себе исторические факты и авторские идеи. Книга входит в цикл произведений, где главным героем является профессор Роберт Лэнгдон. События книги происходят в Вашингтоне, уже пос...",
        age: "16+",
        genre: "Роман",
        author: "Дэн Браун",
        img: "/images/books/Утраченный символ.jpg",
        price: 285,
      },
      {
        id: "3",
        article: "3",
        title: "Код да Винчи",
        description:
          "Убийство Жака Соньера наделало в Париже много шума – не только благодаря тому, что он был хорошо известен в узких кругах, но и потому, что расположение трупа в точности повторяло картину Да Винчи «Ветрувианский человек». Кто и зачем мог это сделать? Почему полиция подозревает в убийстве известног...",
        age: "16+",
        genre: "Детектив, история",
        author: "Дэн Браун",
        img: "/images/books/Код да Винчи.jpg",
        price: 290,
      },
      {
        id: "4",
        article: "4",
        title: "Цифровая крепость",
        description:
          "Динамичный детективный триллер Дэна Брауна («Код да Винчи», «Ангелы и демоны») приглашает читателя в святая святых Агентства национальной безопасности Америки. Здесь происходит немыслимое: суперкомпьютер не может расшифровать код, который, предположительно, был создан посредством программы «Цифро...",
        age: "16+",
        genre: "Детектив, триллер",
        author: "Дэн Браун",
        img: "/images/books/Цифровая крепость.jpg",
        price: 315,
      },
      {
        id: "5",
        article: "5",
        title: "Точка обмана",
        description:
          "Встречайте остросюжетный триллер Дэна Брауна, автора культовых романов «Код Да Винчи» и «Ангелы и Демоны», с успехом экранизированных Голливудом. В книге «Точка обмана» Дэн Браун попытался обличить деятельность НАСА. Популярный американский писатель рассказывает об артефакте, который был найден в...",
        age: "16+",
        genre: "Детектив, триллер, антиутопия",
        author: "Дэн Браун",
        img: "/images/books/Точка обмана.jpg",
        price: 277,
      },
      {
        id: "6",
        article: "6",
        title: "Ангелы и демоны",
        description:
          "Дэна Брауна по праву можно назвать одним из самых загадочных авторов нашего времени. Автор приоткрывает завесу тайны древнего, прославленного средневекового ордена иллюминатов, который вел ожесточенную борьбу с официальной церковью. И, казалось бы, это уже давно часть человеческой истории, но все...",
        age: "16+",
        genre: "История",
        author: "Дэн Браун",
        img: "/images/books/Ангелы и демоны.jpg",
        price: 341,
      },
      {
        id: "7",
        article: "7",
        title: "Происхождение",
        description:
          "Роберт Лэнгдон прибывает в музей Гуггенхайма в Бильбао по приглашению друга и бывшего студента Эдмонда Кирша. Миллиардер и компьютерный гуру, он известен своими удивительными открытиями и предсказаниями. И этим вечером Кирш собирается «перевернуть все современные научные представления о мире», да...",
        age: "16+",
        genre: "История, секреты",
        author: "Дэн Браун",
        img: "/images/books/Происхождение.jpg",
        price: 355,
      },
    ],
  },
  {
    author: "Джордж Оруэлл",
    books: [
      {
        id: "8",
        article: "8",
        title: "1984",
        description:
          "Первые полвека после публикации антиутопия Оруэлла «1984» воспринималась как злая сатира на коммунистические режимы.Но, увы, пророческие детали мира «1984» всё больше и больше становятся реальностью современного декоммунизированного мира.Фантастические реалии, придуманные Джорджем Оруэллом для Бр...",
        age: "17+",
        genre: "Антиутопия",
        author: "Джордж Оруэлл",
        img: "/images/books/1984.jpg",
        price: 307,
      },
      {
        id: "9",
        article: "9",
        title: "Да здравствует фикус!",
        description:
          "Разве деньги -это не величайшее изобретение человечества? Судите сами. Во-первых, деньги – это универсальная единица измерения для каждого достижения, причем применена она может быть не только к материальным, но и духовным величинам. Во-вторых, деньги – это финансовая независимость и власть. Разве мы не стремимся к ней всеми силами? Ну и в-третьих, деньги – это иерархическая лестница, при их помощи мы можем достигнуть вершины или упасть вниз. А что произойдет, если мы объявим деньгам войну? Главный герой романа «Да здравствует фикус!» решил испытать это на себе. Отказавшись от денег, статуса и прочих материальных благ.",
        age: "16+",
        genre: "Зарубежная классика",
        author: "Джордж Оруэлл",
        img: "/images/books/Да здравствует фикус!.jpg",
        price: 337,
      },
      {
        id: "10",
        article: "10",
        title: "Дочь священника",
        description:
          "Героиня романа – дочь священника Дороти, глубоко верующая и ведущая праведный образ жизни, – в результате несчастного случая теряет память и напрочь забывает о своей вере в Бога. Дороти становится мелкой мошенницей и прибивается к банде бродяг. Через какое-то время память возвращается к ней, но не вера…",
        age: "16+",
        genre: "Зарубежная классика",
        author: "Джордж Оруэлл",
        img: "/images/books/Дочь священника.jpg",
        price: 360,
      },
      {
        id: "11",
        article: "11",
        title: "Глотнуть воздуха",
        description:
          "Джорджу Боулингу всего сорок пять, но он все чаще и чаще начинает задумываться о никчемности своей жизни. Он недоволен всем: своим внешним видом, работой, семьей. Настоящее для него невыносимо. А вот прошлое, напротив, вызывает только приятные воспоминания. Небольшой городок с парой магазинов и рыночной площадью, где прошло детство Джорджа, родительский дом и большое озеро с огромными рыбами, и ни с чем не сравнимый воздух, такой сладкий и пьянящий, каким он может быть только в беззаботной юности. А что, если еще не поздно вернуть все это? Ну что ж, решено. И после недолгих колебаний Джордж отправляется в город своей мечты, где он когда-то был так бесконечно счастлив.",
        age: "16+",
        genre: "Литература 20 века",
        author: "Джордж Оруэлл",
        img: "/images/books/Глотнуть воздуха.jpg",
        price: 385,
      },
      {
        id: "12",
        article: "12",
        title: "Дни в Бирме",
        description:
          "Британский холостяк Джон Флори ведет беззаботную праздную жизнь в колониальной Индии. Как и остальные представители «высшего класса» он проводит время за игрой в теннис, беспробудным пьянством и развлечениями с бесчисленными женщинами. Знакомство с молодой англичанкой и дружба с индийским врачом Верасвами заставляет его взглянуть на происходящее вокруг совсем другими глазами. Хронологически, «Дни в Бирме» – это первый роман Оруэлла. После четырех лет службы в колониальной Бирме офицером Имперской военной полиции он написал эту автобиографичную книгу, отразившую весь опыт тех непростых лет и послужившим в дальнейшем основанием для всей его оригинальной и чрезвычайно независимой жизненной позиции.",
        age: "16+",
        genre: "Классическая проза",
        author: "Джордж Оруэлл",
        img: "/images/books/Дни в Бирме.jpg",
        price: 355,
      },
      {
        id: "13",
        article: "13",
        title: "Памяти Каталонии. Эссе (сборник)",
        description:
          "Гражданская война в Испании – глазами очевидца и участника боевых действий. Война во всей ее неприглядности, со всеми противоречиями, играми и ложью тех, кто пытался на ней нажиться, и отчаянной самоотверженностью тех, кто верил в то, за что сражался… Книга горькая, откровенная и честная. И еще – очень «неудобная» для многих политиков, а потому – прежде выходившая с серьезными купюрами.",
        age: "16+",
        genre: "Документальная литература",
        author: "Джордж Оруэлл",
        img: "/images/books/Памяти Каталонии. Эссе (сборник).jpg",
        price: 345,
      },
      {
        id: "14",
        article: "14",
        title: "Славно, славно мы резвились",
        description:
          "В сборник включены его критические размышления на самые разные темы – от современной литературы и кино до поэтики и политики. Заглавное же место занимает автобиографическое эссе «Славно, славно мы резвились», в котором Оруэлл со всей откровенностью описывает непростой этап взросления и без прикрас рассказывает о своей учебе в школе Святого Киприана, язвительно осуждая лицемерную систему эдвардианского образования.",
        age: "16+",
        genre: "Публицистика",
        author: "Джордж Оруэлл",
        img: "/images/books/Славно, славно мы резвились.jpg",
        price: 335,
      },
      {
        id: "15",
        article: "15",
        title: "Дорога на Уиган-Пирс",
        description:
          "В 1936 году, по заданию социалистического книжного клуба, Оруэлл отправляется в индустриальные глубинки Йоркшира и Ланкашира для того, чтобы на месте ознакомиться с положением дел на шахтерском севере Англии. Результатом этой поездки стала повесть «Дорога на Уиган-Пирс», рассказывающая о нечеловеческих условиях жизни и работы шахтеров. С поразительной дотошностью Оруэлл не только изучил и описал кошмарный труд в забоях и ужасные жилищные условия рабочих, но и попытался понять и дать объяснение, почему, например, безработный бедняк предпочитает покупать белую булку и конфеты вместо свежих овощей и полезного серого хлеба. В конечном итоге эта книга привела к разрыву автора с прогрессивным издателем. Социализм, о котором там горячо толкует Оруэлл, оскорбил правоверного западного социалиста насмешками над теорией марксизма и практикой сталинизма, поскольку оруэлловский социализм – это просто-напросто человечность и ничего другого.",
        age: "16+",
        genre: "Зарубежная публицистика",
        author: "Джордж Оруэлл",
        img: "/images/books/Дорога на Уиган-Пирс.jpg",
        price: 375,
      },
    ],
  },
  {
    author: "Олдос Хаксли",
    books: [
      {
        id: "16",
        article: "16",
        title: "О дивный новый мир",
        description:
          "«О дивный новый мир» – антиутопия об «обществе потребления», в основах которого лежат генетическое программирование и строгий контроль над размножением, и об одном человеке, для которого это общество становится чужим. Текст произведения снабжен грамматическим комментарием и словарем, в который во...",
        age: "15+",
        genre: "Антиутопия",
        author: "Олдос Хаксли",
        img: "/images/books/О дивный новый мир.jpg",
        price: 405,
      },
    ],
  },
  {
    author: "Михаил Булгаков",
    books: [
      {
        id: "17",
        article: "17",
        title: "Мастер и Маргарита",
        description:
          "«Мастер и Маргарита» — это роман, который стоит особняком от остальных книг, изданных в советский период. Параллельно в книге развиваются несколько сюжетных линий, а реальное смешивается с фантастическим и мистическим. Книга предлагает нам исследовать разные временные периоды, а также забраться в...",
        age: "13+",
        genre: "Роман",
        author: "Михаил Булгаков",
        img: "/images/books/Мастер и Маргарита.jpg",
        price: 247,
      },
    ],
  },
  {
    author: "Рэй Брэдбери",
    books: [
      {
        id: "18",
        article: "18",
        title: "451 градус по Фаренгейту",
        description:
          "«451 градус по Фаренгейту» – научно-фантастический роман Рэя Брэдбери, который входит в популярную серию «Классика для ленивых». Действие романа происходит в тоталитарном обществе, которое запрещает своим членам читать книги, содержащие философский смысл. Такие издания должны быть сожжены, а те, ...",
        age: "15+",
        genre: "История, антиутопия, будущее",
        author: "Рэй Брэдбери",
        img: "/images/books/451 градус по Фаренгейту.jpg",
        price: 380,
      },
    ],
  },
  {
    author: "Сергей Носов",
    books: [
      {
        id: "19",
        article: "19",
        title: "Одиссея",
        description:
          "Перед вами оригинальное прозаическое переложение поэмы Гомера «Одиссея», выполненное Сергеем Носовым и рассчитанное на восприятие сегодняшним читателем. «Одиссея», много веков служившая источником вдохновения для поэтов, художников и композиторов, не нуждается в представлении, хотя – будем честны – подавляющее большинство современников знакомо с этим литературным памятником исключительно по экранизациям.",
        age: "16+",
        genre: "Мифы, легенды, эпос",
        author: "Сергей Носов",
        img: "/images/books/Одиссея.jpg",
        price: 245,
      },
    ],
  },
  {
    author: "Тана Френч",
    books: [
      {
        id: "20",
        article: "20",
        title: "Фейтфул-Плейс",
        description:
          "В 1985 году Фрэнку Мэкки было девятнадцать, он мечтал сбежать из тесной квартиры своей безумной семьи на Фейтфул-Плейс и вместе со своей девушкой Рози перебраться из Дублина в Лондон. Но Рози в ночь, на которую юные влюбленные запланировали побег в новую жизнь, не пришла на место встречи. Спустя двадцать два года Фрэнк – один из лучших детективов полиции Дублина. И однажды в заброшенном доме на Фейтфул-Плейс строители находят старенький чемодан, находка указывает на то, что исчезновение Рози, возможно, объясняется вовсе не ее бегством. Нравится это Фрэнку или нет, но он вынужден вернуться в район, где родился и вырос, к родным, от которых так старался держаться подальше.",
        age: "18+",
        genre: "Триллеры",
        author: "Тана Френч",
        img: "/images/books/Фейтфул-Плейс.jpg",
        price: 245,
      },
    ],
  },
  {
    author: "АНОНИМУС",
    books: [
      {
        id: "21",
        article: "21",
        title: "Дело Зили-султана",
        description:
          "Расследуя довольно заурядное дело, старший следователь Волин случайно наткнулся на тайник со старинными дневниками. А там… а там он находит зашифрованные записи таинственного надворного советника Икс, гения разведки и уголовного сыска XIX века. На пожелтевших страницах разворачивается шпионская история, в которой даже самый близкий человек может оказаться предателем, за каждым углом подстерегает смертельная опасность, а любая ошибка грозит обернуться не только провалом операции, но и полным крахом для целой страны…",
        age: "16+",
        genre: "Исторические детективы",
        author: "АНОНИМУС",
        img: "/images/books/Дело Зили-султана.jpg",
        price: 280,
      },
      {
        id: "22",
        article: "22",
        title: "Дело Черных дервишей",
        description:
          "Старший следователь Орест Волин расследует дело, связанное с пропажей ценной копии Корана Усмана. Дело осложняется убийством похитителя. Волин приходит к выводу, что на самом деле вор должен был украсть оригинальный Коран Усмана, который является мусульманской святыней и как раз в эти дни был привезен из Ташкента в Петербург.",
        age: "16+",
        genre: "Исторические детективы",
        author: "АНОНИМУС",
        img: "/images/books/Дело Черных дервишей.jpg",
        price: 270,
      },
      {
        id: "23",
        article: "23",
        title: "Тайный дневник Михаила Булгакова",
        description:
          "Наши дни. Следователь Орест Волин получает приказ расследовать дело об убийстве в московском Музее Булгакова. Сотрудница музея, придя утром на работу, обнаружила мертвое тело с ножом в спине. Но затем тело бесследно исчезло. Было ли преступление реальным? Или это чей-то злой розыгрыш? Тем временем Орест Волин получает новости о том, что зашифрованные дневники надворного советника Загорского, которые он обнаружил в ходе предыдущего дела, на самом деле – ранее не публиковавшийся дневник Михаила Булгакова, описывающий события 1918–1921 годов… И как это связано с убийством в Музее Булгакова?",
        age: "16+",
        genre: "Исторические детективы",
        author: "АНОНИМУС",
        img: "/images/books/Тайный дневник Михаила Булгакова.jpg",
        price: 295,
      },
      {
        id: "24",
        article: "24",
        title: "Камень погибели",
        description:
          "Старший следователь Следственного комитета Орест Волин берется за расследование кражи в доме известного коллекционера китайского фарфора. Среди украденных вещиц – китайский болванчик Будда Милэ, который не отличается особой ценностью, но превосходит размерами другие украденные предметы из редкой коллекции. В ходе розыскных действий Орест Волин узнает о знаменитом китайском алмазе «Слеза Будды», по легенде обладавшем огромной магической силой. В 1911 году алмаз был украден и переправлен за границу именно в таком китайском болванчике. Маловероятно, что алмаз до сих пор скрыт в фигурке, но теперь кому-то понадобилось бывшее хранилище сокровища. Кому и для чего? Тем временем старый знакомый Волина, генерал Воронцов, находит в дневниках надворного советника Загорского историю алмаза. И Волин берется за дневник, который рассказывает о событиях, происходящих в Китае и Тибете в 1914 году…",
        age: "16+",
        genre: "Исторические детективы",
        author: "АНОНИМУС",
        img: "/images/books/Камень погибели.jpg",
        price: 310,
      },
      {
        id: "25",
        article: "25",
        title: "Приключения бодхисаттвы",
        description:
          "Наши дни. У крупного предпринимателя Анисима Московкина сгорает квартира. Пострадавший считает, что квартиру подожгли из хулиганских побуждений: из нее ничего не пропало, но в нее подбросили сделанный из фарфора кукиш. Расследование продвигается тяжело. Быть может, следователю Волину поможет новая порция расшифрованных дневников Нестора Загорского, в которых фигурирует дом на Сретенском бульваре, где сейчас живет Московкин? …Очередной мемуар Нестора Васильевича рассказывает, что после того, как карлик Цзяньян-гоче плюнул в Загорского отравленной стрелой, знаменитый сыщик погиб. Однако при помощи магии тибетские ламы-заклинатели ухитряются вернуть душу в тело Загорского. Нестор Васильевич жив, но не осознает себя и не двигается. Верный Ганцзалин возвращается с господином в Россию и находит в Самаре китайского целителя, который возвращает сыщика к нормальной жизни. Но порадоваться этому обстоятельству Загорский не успевает…",
        age: "16+",
        genre: "Исторические детективы",
        author: "АНОНИМУС",
        img: "/images/books/Приключения бодхисаттвы.jpg",
        price: 315,
      },
    ],
  },
  {
    author: "Ильдефонсо Фальконес",
    books: [
      {
        id: "26",
        article: "26",
        title: "Собор у моря",
        description:
          "Дебютный роман испанского писателя Ильдефонсо Фальконеса, мгновенно ставший мировым бестселлером. Книга была издана более чем в 30 странах, и ее тираж превысил 2 миллиона экземпляров; в 2018 году по книге был снят телевизионный сериал. «Собор у моря» – это захватывающий исторический роман, действие которого разворачивается в средневековой Барcелоне, богатой и процветающей столице Каталонии. С этим городом навсегда соединилась полная взлетов и падений судьба главного героя Арнау Эстаньола, отец которого, беглый серв, оказался в Барселоне в поисках свободы, спасаясь от произвола своего хозяина. Жестокость средневековых нравов и беспредел знати, костры инквизиции и бубонная чума, интриги и заговоры, войны, насилие, голод и кровь, обман и предательство, любовь и верность – все это на фоне строительства одного из самых прекрасных в мире храмов – барселонского собора Святой Марии у Моря, дарующей силу и свет.",
        age: "16+",
        genre: "Современная зарубежная литература",
        author: "Ильдефонсо Фальконес",
        img: "/images/books/Собор у моря.jpg",
        price: 325,
      },
      {
        id: "27",
        article: "27",
        title: "Живописец душ",
        description:
          "Добро пожаловать в Барселону начала XX века – расцвет модернизма, столкновение идеологий, конфликт поколений, бурлят споры, кипит кровь. Молодой художник Далмау Сала, влюбленный в жизнь, в живопись, в женщину, разрывается между подлинным искусством, требующим полной самоотдачи, и необязательными, но удобными поделками для богатых и равнодушных, между наслаждением и долгом, между романтикой и комфортом. Далмау ищет себя и свой истинный путь – и вместе с возлюбленной пройдет страшными тропами посреди восторга и ужаса мира, стоящего на пороге нового века.",
        age: "18+",
        genre: "Историческая литература",
        author: "Ильдефонсо Фальконес",
        img: "/images/books/Живописец душ.jpg",
        price: 305,
      },
    ],
  },
  {
    author: "Евгений Водолазкин",
    books: [
      {
        id: "28",
        article: "28",
        title: "Авиатор",
        description:
          "Герой нового романа “Авиатор” – человек в состоянии tabula rasa: очнувшись однажды на больничной койке, он понимает, что не знает про себя ровным счетом ничего – ни своего имени, ни кто он такой, ни где находится. В надежде восстановить историю своей жизни, он начинает записывать посетившие его воспоминания, отрывочные и хаотичные: Петербург начала ХХ века, дачное детство в Сиверской и Алуште, гимназия и первая любовь, революция 1917-го, влюбленность в авиацию, Соловки… Но откуда он так точно помнит детали быта, фразы, запахи, звуки того времени, если на календаре – 1999 год?",
        age: "16+",
        genre: "Современная русская литература",
        author: "Евгений Водолазкин",
        img: "/images/books/Авиатор.jpg",
        price: 245,
      },
      {
        id: "29",
        article: "29",
        title: "Брисбен",
        description:
          "Евгений Водолазкин в своем новом романе «Брисбен» продолжает истории героев («Лавр», «Авиатор»), судьба которых – как в античной трагедии – вдруг и сразу меняется. Глеб Яновский – музыкант-виртуоз – на пике успеха теряет возможность выступать из-за болезни и пытается найти иной смысл жизни, новую точку опоры. В этом ему помогает… прошлое – он пытается собрать воедино воспоминания о киевском детстве в семидесятые, о юности в Ленинграде, настоящем в Германии и снова в Киеве уже в двухтысячные. Только Брисбена нет среди этих путешествий по жизни. Да и есть ли такой город на самом деле? Или это просто мираж, мечтания, утопический идеал, музыка сфер?",
        age: "16+",
        genre: "Современная русская литература",
        author: "Евгений Водолазкин",
        img: "/images/books/Брисбен.jpg",
        price: 255,
      },
      {
        id: "30",
        article: "30",
        title: "Оправдание Острова",
        description:
          "Действие нового романа разворачивается на Острове, которого нет на карте, но существование его не вызывает сомнений. Его не найти в учебниках по истории, а события – узнаваемы до боли. Средневековье переплетается с современностью, всеобщее – с личным, а трагизм – с гротеском. Здесь легко соседствуют светлейшие князья и председатели Острова, хронисты и пророки, повелитель пчел и говорящий кот. Согласно древнему предсказанию, Остров ждут большие испытания. Сможет ли он пройти их, когда земля начинает уходить из-под ног?..",
        age: "16+",
        genre: "Современная русская литература",
        author: "Евгений Водолазкин",
        img: "/images/books/Оправдание Острова.jpg",
        price: 280,
      },
      {
        id: "31",
        article: "31",
        title: "Соловьев и Ларионов",
        description:
          "«Соловьев и Ларионов» – ранний роман Водолазкина – написан в русле его магистральной темы: столкновение времён, а в конечном счете – преодоление времени. Молодой историк Соловьев с головой окунается в другую эпоху, воссоздавая историю жизни белого генерала Ларионова, – и это вдруг удивительным образом начинает влиять на его собственную жизнь. И вот уже сквозь современную научную конференцию проступает Ялта двадцатых годов и горящий в Гражданской войне Крым…",
        age: "16+",
        genre: "Современная русская литература",
        author: "Евгений Водолазкин",
        img: "/images/books/Соловьев и Ларионов.jpg",
        price: 270,
      },
      {
        id: "32",
        article: "32",
        title: "Совсем другое время",
        description:
          "«Совсем другое время» – новая книга Водолазкина. И в ней он, словно опровергая название, повторяет излюбленную мысль: «времени нет, всё едино и всё связано со всем». Молодой историк с головой окунается в другую эпоху, восстанавливая историю жизни белого генерала («Соловьев и Ларионов»), и это вдруг удивительным образом начинает влиять на его собственную жизнь; немецкий солдат, дошедший до Сталинграда («Близкие друзья»), спустя десятилетия возвращается в Россию, чтобы пройти этот путь еще раз…",
        age: "16+",
        genre: "Современная русская литература",
        author: "Евгений Водолазкин",
        img: "/images/books/Совсем другое время.jpg",
        price: 290,
      },
      {
        id: "33",
        article: "33",
        title: "Идти бестрепетно. Между литературой и жизнью",
        description:
          "В новой книге «Идти бестрепетно» на первый план выходит сам автор. «Маленький личный Рай детства», история семьи, родные Петербург и Киев, Пушкинский Дом и занятия наукой, переход от филолога-медиевиста к писателю, впервые рассказанные подробности создания «Лавра», «Авиатора», «Брисбена»… В откровенном и доверительном разговоре с читателем остается неизменной фирменная магия текста: в ряд к Арсению-Лавру, авиатору Платонову и виртуозу Глебу Яновскому теперь встает сам Водолазкин.",
        age: "16+",
        genre: "Современная русская литература",
        author: "Евгений Водолазкин",
        img: "/images/books/Идти бестрепетно. Между литературой и жизнью.jpg",
        price: 315,
      },
      {
        id: "34",
        article: "34",
        title: "Лавр",
        description:
          "Удивительная книга написана в форме роман-житие. Действие переносит читателя в Средневековую Русь XV века. Арсений, главный герой романа, человек необычный. Он обладает знаниями как необходимыми, так и опасными для своего времени – он целитель и травник. Его возлюбленная и невенчанная жена Устина умирает во время родов, не успев разрешиться от бремени. Горе Арсения безгранично. Целью своей жизни он избирает искупление греха и отмаливание души возлюбленной. Он странствует по свету, исцеляя больных. Приняв образ юродивого, он бредёт к Иерусалиму. Постригаясь в монахи, а затем и в схиму травник Арсений берёт себе другое имя – теперь он Лавр.",
        age: "18+",
        genre: "Историческая литература",
        author: "Евгений Водолазкин",
        img: "/images/books/Лавр.jpg",
        price: 335,
      },
    ],
  },
  {
    author: "Джеймс Клавелл",
    books: [
      {
        id: "35",
        article: "35",
        title: "Гайдзин",
        description:
          "Япония. 1862 год. Наследник великолепного Благородного Дома, развернувшего свою деятельность в Стране восходящего солнца… Прямой потомок первого сёгуна Торанаги, сражающегося за то, чтобы его страна преодолела средневековые традиции и вступила в современную эпоху… Красивая молодая француженка, которая разрывается между честолюбием и любовью… Их жизни переплетаются на экзотической земле, вновь открытой для иностранцев – гайдзинов. Их страсти смешиваются с желаниями монархов и дипломатов, убийц, куртизанок и шпионов.",
        age: "16+",
        genre: "Зарубежные приключения",
        author: "Джеймс Клавелл",
        img: "/images/books/Гайдзин.jpg",
        price: 345,
      },
      {
        id: "36",
        article: "36",
        title: "Благородный Дом. Роман о Гонконге. Книга 1. На краю пропасти",
        description:
          "1963 год. Таинственный и романтичный Гонконг – сердце Азии. Более ста лет назад Дирк Струан, создавший Благородный Дом, мечтал превратить пустынный остров в процветающую колонию и оттуда управлять Азией. И теперь здесь главную роль играют финансы, торговля, судоходство и большой бизнес. В руках Иэна Данросса, нынешнего главы Благородного Дома и блестящего бизнесмена, сосредоточена огромная власть, которую он использует, чтобы спасти компанию от финансового краха. Для этого все способы хороши: переговоры с американским миллионером, рискованная игра на бирже и даже взаимодействие с гонконгскими триадами. Во что бы то ни стало Иэн должен удержать компанию. И у него есть всего неделя…",
        age: "16+",
        genre: "Зарубежные приключения",
        author: "Джеймс Клавелл",
        img: "/images/books/Благородный Дом. Роман о Гонконге. Книга 1. На краю пропасти.jpg",
        price: 335,
      },
      {
        id: "37",
        article: "37",
        title: "Тайпан",
        description:
          "Южный Китай в 1840–1841 годах. Европейские торговцы и авантюристы впервые начали проникать в Китай, сказочно богатую, полную опасностей и загадок страну. Жизнью платили эти люди за слабость, нерешительность и незнание обычаев Востока. И в это время англичанин Дирк Струан поставил себе целью превратить пустынный остров Гонконг в несокрушимый оплот британского могущества и подняться на вершину власти, став верховным повелителем – тайпаном.",
        age: "16+",
        genre: "Зарубежные приключения",
        author: "Джеймс Клавелл",
        img: "/images/books/Тайпан.jpg",
        price: 345,
      },
      {
        id: "38",
        article: "38",
        title: "Благородный Дом. Роман о Гонконге. Книга 2. Рискованная игра",
        description:
          "Почуяв слабость Благородного Дома, непримиримые враги, заклятые соперники и даже друзья строят планы по захвату компании, желая урвать кусок пожирнее. Американец ведет двойную игру, вступая в переговоры с давним противником Благородного Дома. Друзья и члены самой семьи Иэна, желая поживиться, готовы продать секреты, причем как можно дороже. Бурные события сменяют друг друга с невероятной скоростью. Здесь и похищения, убийства, финансовые махинации, противостояние семейств, предательство, любовь, интриги, стихийные бедствия и неумолимое течение судьбы. Благородный Дом стоит на краю пропасти. Лишь чудо может спасти его…",
        age: "16+",
        genre: "Зарубежные приключения",
        author: "Джеймс Клавелл",
        img: "/images/books/Благородный Дом. Роман о Гонконге. Книга 2. Рискованная игра.jpg",
        price: 370,
      },
      {
        id: "39",
        article: "39",
        title: "Ураган. Книга 1. Потерянный рай",
        description:
          "Февраль 1979 года. Иран. Шах бежал, и к власти пришел аятолла Хомейни. В стране кипят страсти, активно действуют фанатики ислама, революционеры всякого толка, не остаются в стороне и спецслужбы великих держав, крайне заинтересованных в иранской нефти. Спокойная жизнь пилотов вертолетной компании, которой негласно управляет Благородный Дом, закончилась: необходимо получать разрешения на запуск двигателей, на взлет, на полет в определенное место. В такой обстановке компания практически поставлена на грань выживания, и ее руководство решает прекратить работу, вывезти вертолеты и людей в безопасное место…",
        age: "16+",
        genre: "Зарубежные приключения",
        author: "Джеймс Клавелл",
        img: "/images/books/Ураган. Книга 1. Потерянный рай.jpg",
        price: 375,
      },
      {
        id: "40",
        article: "40",
        title: "Король крыс",
        description:
          "Идет Вторая мировая война, но здесь, в японском лагере для военнопленных, не слышны звуки битвы. Здесь офицеры и солдаты ведут собственную войну за выживание в нечеловеческих условиях. Кинг, американский капрал, стремится к доминированию и над пленниками, и над захватчиками. Его оружие – это бесстрашие и великолепное знание человеческих слабостей. Он готов использовать любую возможность, чтобы расширить свою власть и развратить или уничтожить любого, кто стоит на его пути. Кинг перепродает ценные предметы пленников охранникам лагеря за деньги, на которые можно купить контрабандную еду. Это противоречит японским правилам и, таким образом, правилам лагеря, но большинство офицеров закрывают глаза на торговлю. Робин Грей является исключением, и он намеревается поймать Кинга.",
        age: "16+",
        genre: "Книги о войне",
        author: "Джеймс Клавелл",
        img: "/images/books/Король крыс.jpg",
        price: 385,
      },
      {
        id: "41",
        article: "41",
        title: "Ураган. Книга 2. Бегство из рая",
        description:
          "Февраль 1979 года. Иран. Шах бежал, и к власти пришел аятолла Хомейни. В стране кипят страсти, активно действуют фанатики ислама, революционеры всякого толка, не остаются в стороне и спецслужбы великих держав, крайне заинтересованных в иранской нефти. Спокойная жизнь пилотов вертолетной компании, которой негласно управляет Благородный Дом, закончилась. В такой обстановке компания разрабатывает операцию по вывозу вертолетов и людей из страны, где царит разруха, фанатизм и насилие, и приступает к ее осуществлению. Задача осложняется тем, что все вертолеты должны вылететь со своих баз одновременно, а иначе операция не состоится…",
        age: "16+",
        genre: "Литература 20 века",
        author: "Джеймс Клавелл",
        img: "/images/books/Ураган. Книга 2. Бегство из рая.jpg",
        price: 340,
      },
      {
        id: "42",
        article: "42",
        title: "Сёгун",
        description:
          "Начало XVII века. Голландское судно терпит крушение у берегов Японии. Выживших членов экипажа берут в плен и обвиняют в пиратстве. Среди попавших в плен был и англичанин Джон Блэкторн, прекрасно знающий географию, военное дело и математику и обладающий сильным характером. Их судьбу должен решить местный правитель, прибытие которого ожидает вся деревня. Слухи о талантливом капитане доходят до князя Торанага-но Миновара, одного из самых могущественных людей Японии. Торанага берет Блэкторна под свою защиту, лелея коварные планы использовать его знания в борьбе за власть. Чтобы выжить в чужой стране, англичанин изучает ее язык и обычаи, становится самураем, но его не покидает мысль, что когда-нибудь ему все-таки удастся вернуться на родину…",
        age: "16+",
        genre: "Исторические приключения",
        author: "Джеймс Клавелл",
        img: "/images/books/Сёгун.jpg",
        price: 315,
      },
    ],
  },
  {
    author: "Дафна дю Морье",
    books: [
      {
        id: "43",
        article: "43",
        title: "В погоне за счастьем, или Мэри-Энн",
        description:
          "У Мэри-Энн была невероятная судьба и невероятный характер, в котором сочетались расчетливость и безрассудность, доверчивость и лукавство, язвительность и добродушие, бесстрашие и распутность… Ей удалось выбраться из убогих лондонских трущоб, став известной куртизанкой и любовницей герцога Йоркского, брата короля Георга III, достичь высот власти, а затем, ввязавшись в громкий коррупционный скандал и политические интриги, она поставила на карту свое будущее и свою жизнь…",
        age: "16+",
        genre: "Литература 20 века",
        author: "Дафна дю Морье",
        img: "/images/books/В погоне за счастьем, или Мэри-Энн.jpg",
        price: 415,
      },
    ],
  },
  {
    author: "Айн Рэнд",
    books: [
      {
        id: "44",
        article: "44",
        title: "Атлант расправил плечи",
        description:
          "К власти в США приходят социалисты и правительство берет курс на «равные возможности», считая справедливым за счет талантливых и состоятельных сделать богатыми никчемных и бесталанных. Гонения на бизнес приводят к разрушению экономики, к тому же один за другим при загадочных обстоятельствах начинают исчезать талантливые люди и лучшие предприниматели. Главные герои романа стальной король Хэнк Риарден и вице-президент железнодорожной компании Дагни Таггерт тщетно пытаются противостоять трагическим событиям. Вместо всеобщего процветания общество погружается в апатию и хаос.",
        age: "16+",
        genre: "Литература 20 века",
        author: "Айн Рэнд",
        img: "/images/books/Атлант расправил плечи.jpg",
        price: 549,
      },
      {
        id: "45",
        article: "45",
        title: "Источник",
        description:
          "Главные герои романа – архитектор Говард Рорк и журналистка Доминик Франкон – отстаивают свободу творческой личности в борьбе с обществом, где ценят «равные возможности» для всех. Вместе и поодиночке, друг с другом и друг против друга, но всегда – наперекор устоям толпы. Они – индивидуалисты, их миссия – творить и преобразовывать мир.",
        age: "16+",
        genre: "Зарубежная классика",
        author: "Айн Рэнд",
        img: "/images/books/Источник.jpg",
        price: 549,
      },
      {
        id: "46",
        article: "46",
        title: "Мы живые",
        description:
          "Это первый роман известной американской писательницы русского происхождения. Главная его тема – человек против государства, личное счастье против общественного блага – мастерски проведена через фон драматических событий в жизни Петрограда-Ленинграда начала 20-х годов. Автор без какого-либо снисхождения к своим героям рассказывает нам о том смутном периоде нашей истории. Бывший аристократ в служебном рвении перед новым режимом предает друзей и близких. Герой Гражданской войны после всех своих побед изменяет делу партии. Любовь главной героини к сыну расстрелянного адмирала приводит к любовной связи с сотрудником ГПУ.",
        age: "16+",
        genre: "Зарубежная классика",
        author: "Айн Рэнд",
        img: "/images/books/Мы живые.jpg",
        price: 549,
      },
      {
        id: "47",
        article: "47",
        title: "Добродетель эгоизма",
        description:
          "Книга «Добродетель эгоизма» представляет собой сборник статей, написанных Айн Рэнд в разные годы и объединенных одной темой – защитой концепции «разумного эгоизма» как этической основы свободного капиталистического общества. Автор на редкость живо и убедительно доказывает, что только в рамках системы, которая ставит во главу угла права личности и разум, люди могут свободно развиваться и обретать счастье, не оказываясь порабощенными диктаторами, государством и другими людьми. А значит – только такую систему можно признать нравственной и соответствующей человеческой природе.",
        age: "16+",
        genre: "Зарубежная публицистика",
        author: "Айн Рэнд",
        img: "/images/books/Добродетель эгоизма.jpg",
        price: 529,
      },
      {
        id: "48",
        article: "48",
        title: "Капитализм. Незнакомый идеал",
        description:
          "Книга «Капитализм: Незнакомый идеал» представляет собой сборник статей, написанных Айн Рэнд в разные годы, которые и сегодня поражают своей злободневностью, остротой и убедительностью. В них автор на реальных примерах из общественной, политической и экономической жизни блестяще доказывает основной посыл своей философии: человека может сделать свободным и счастливым только система, ставящая во главу угла личность, система, основанная на рациональности, свободном обмене идеями и товарами, а именно – капитализм. А значит – только такую систему можно считать нравственной, и любые идеологические компромиссы способны нанести человечеству лишь вред.",
        age: "0+",
        genre: "Зарубежная публицистика",
        author: "Айн Рэнд",
        img: "/images/books/Капитализм. Незнакомый идеал.jpg",
        price: 569,
      },
      {
        id: "49",
        article: "49",
        title: "Романтический манифест. Философия литературы",
        description:
          "Как писательница, Айн Рэнд знала творческий процесс изнутри, как философ, она считала необходимым его осмыслить. Почему «Анна Каренина» является самым вредным произведением мировой литературы, а Виктор Гюго – величайшим писателем-романтиком? В чем цель искусства и кто его главный враг? Можно ли считать искусство «служанкой» морали и что объединяет его с романтической любовью? С бескомпромиссной честностью автор отвечает на эти и другие вопросы и прорывается через туманную дымку, традиционно окутывающую предмет искусства.",
        age: "12+",
        genre: "Зарубежная публицистика",
        author: "Айн Рэнд",
        img: "/images/books/Романтический манифест. Философия литературы.jpg",
        price: 539,
      },
      {
        id: "50",
        article: "50",
        title: "Возвращение примитива. Антииндустриальная революция",
        description:
          "Кого выпускает современная средняя и высшая школа – независимых, творческих, сильных профессионалов или слабых, безликих невротиков-невежд? Что такое мультикультурность: попытка сделать мир более справедливым, разнообразным и ярким или уступка дикости нецивилизованных народов и шаг назад на пути к прогрессу? Чего на самом деле добиваются зеленые движения, маскируя под лозунгами о защите природы желание вновь загнать человека в прокрустово ложе страха и беспомощности? На эти и другие провокационные вопросы Айн Рэнд отвечает со свойственными ей бескомпромиссностью и мощными аргументами, заручившись поддержкой своего союзника – разума.",
        age: "0+",
        genre: "Зарубежная публицистика",
        author: "Айн Рэнд",
        img: "/images/books/Возвращение примитива. Антииндустриальная революция.jpg",
        price: 549,
      },
      {
        id: "51",
        article: "51",
        title: "Философия: Кому она нужна?",
        description:
          "Для Айн Рэнд философия – это сила, формирующая сознание и характер индивидов и наций; выбор человека не в том, придерживаться ли ему той или иной философской концепции или нет, а в том, какую принять для себя. Писательница критикует этические взгляды Канта, пишет о значимости языка и объясняет, что необходимо для формирования рациональной и сознательной философии.",
        age: "16+",
        genre: "Зарубежная публицистика",
        author: "Айн Рэнд",
        img: "/images/books/Философия Кому она нужна.jpg",
        price: 549,
      },
      {
        id: "52",
        article: "52",
        title: "Голос разума. Философия объективизма. Эссе",
        description:
          "Смерть Мэрилин Монро, освоение космоса, война во Вьетнаме, противостояние США и Советского Союза, позиция женщины в политике, жесткая критика Католической церкви в ее попытках регулировать интимную сторону жизни общества. Эти и другие знаковые события и процессы второй половины XX века Айн Рэнд осмысляет через призму объективистского мировоззрения, оставаясь яростной защитницей индивидуальных свобод и частного капитала.",
        age: "16+",
        genre: "Зарубежная публицистика",
        author: "Айн Рэнд",
        img: "/images/books/Голос разума. Философия объективизма. Эссе.jpg",
        price: 519,
      },
    ],
  },
  {
    author: "Габриэль Гарсиа Маркес",
    books: [
      {
        id: "53",
        article: "53",
        title: "Сто лет одиночества",
        description:
          "«Сто лет одиночества» — культовая книга этого автора, она написана в жанре магического реализма, а значит, что здесь реалистическая картина мира будет дополнена мистическими и фантастическими элементами. Книга построена по кольцевой композиции и повествует о семье Буэндиа и о событиях в деревне Макондо. Название романа не случайно, ведь именно от одиночества больше всего страдают его персонажи — это словно генетическая болезнь семейства Буэндиа. Кроме того, вся деревня живет в изоляции от внешнего мира, ожидая приезда цыган, которые время от времени привозят с собой новые изобретения и рассказы о том, что творится в остальном мире. Прочитайте эту книгу, и вы узнаете, что не только люди, но и целые народы могут быть одиноки.",
        age: "12+",
        genre: "Литература 20 века",
        author: "Габриэль Гарсиа Маркес",
        img: "/images/books/Габриэль Гарсиа Маркес.jpg",
        price: 229,
      },
      {
        id: "54",
        article: "54",
        title: "Осень патриарха",
        description:
          "«Мне всегда хотелось написать книгу об абсолютной власти» – так автор определил главную тему своего произведения. Диктатор неназванной латиноамериканской страны находится у власти столько времени, что уже не помнит, как к ней пришел. Он – и человек, и оживший миф, и кукловод, и марионетка в руках Рока. Он совершенно одинок в своем огромном дворце, где реальное и нереальное соседствуют самым причудливым образом. Он хочет и боится смерти. Но… есть ли смерть для воплощения легенды? Возможно, счастлив властитель станет лишь когда умрет и поймет, что для него «бессчетное время вечности наконец кончилось»?",
        age: "12+",
        genre: "Литература 20 века",
        author: "Габриэль Гарсиа Маркес",
        img: "/images/books/Осень патриарха.jpg",
        price: 549,
      },
      {
        id: "55",
        article: "55",
        title: "Полковнику никто не пишет",
        description:
          "Прежде чем опубликовать эту повесть Габриэль Гарсиа Маркес переписывал ее десяток раз и добился своего: по своей емкости и силе она не имеет себе равных во всей латиноамериканской прозе. Внешне ее сюжетная канва незатейлива – всего лишь сменилась в латиноамериканской стране в очередной раз власть, очередные столичные коррупционеры в который раз наживают состояния – а герой давно пролетевшей гражданской войны, престарелый полковник в отставке, влачит в маленьком провинциальном городке полунищенское существование… Но его история, история маленького человека, в одиночку отстаивающего свое достоинство, становится историей преодоления одиночества, произвола и абсурда, царящих в мире.",
        age: "12+",
        genre: "Историческая литература",
        author: "Габриэль Гарсиа Маркес",
        img: "/images/books/Полковнику никто не пишет.jpg",
        price: 250,
      },
      {
        id: "56",
        article: "56",
        title: "Двенадцать рассказов-странников",
        description:
          "Двенадцать маленьких шедевров. Двенадцать коротких историй о латиноамериканцах в Европе. Барселона. Бразильская «ночная бабочка» одержима идеей научить своего пса оплакивать могилу, которая станет последним местом ее упокоения… Женева. Изгнанный диктатор маленькой карибской страны становится постояльцем в доме водителя «скорой помощи»…  Тоскана. Семейство туристов неожиданно встречается с призраком в замке, где теперь обитает знаменитый писатель из Венесуэлы…",
        age: "18+",
        genre: "Литература 20 века",
        author: "Габриэль Гарсиа Маркес",
        img: "/images/books/Двенадцать рассказов-странников.jpg",
        price: 380,
      },
      {
        id: "57",
        article: "57",
        title: "Рассказ человека, оказавшегося за бортом корабля",
        description:
          "«Документальный роман», посвященный истории восьми моряков военного корабля, смытых за борт во время шторма и найденных только через десять дней. Что пережили эти люди? Как боролись за жизнь? Обычный писатель превратил бы эту историю в публицистическое произведение – но под пером Маркеса реальные события стали основой для гениальной притчи о мужестве и судьбе, тяготеющей над каждым человеком. О судьбе, которую можно и нужно преодолеть…",
        age: "12+",
        genre: "Современная зарубежная литература",
        author: "Габриэль Гарсиа Маркес",
        img: "/images/books/Рассказ человека, оказавшегося за бортом корабля.jpg",
        price: 370,
      },
      {
        id: "58",
        article: "58",
        title: "Палая листва",
        description:
          "Первая история Габриэля Гарсиа Маркеса о городке Макондо. Первое произведение, в котором появляется культовый герой писателя – полковник Аурелиано Буэндиа. Одиночество, долг, любовь, мужество, дружба, страсть и смерть – главные темы творчества Маркеса. Именно они стали ключевыми и в повести «Палая листва». Двадцать пять лет жизни Макондо проходят перед читателем в воспоминаниях Аурелиано, его дочери и внука. Двадцать пять лет жизни, полно",
        age: "12+",
        genre: "Литература 20 века",
        author: "Габриэль Гарсиа Маркес",
        img: "/images/books/Палая листва.jpg",
        price: 375,
      },
    ],
  },
  {
    author: "Эрих Мария Ремарк",
    books: [
      {
        id: "59",
        article: "59",
        title: "Жизнь взаймы",
        description:
          "Один из самых пронзительных романов в зарубежной литературе, история любви, которая трагически заканчивается из-за болезни. Эта книга была написана Эрихом Марией Ремарком, немецким писателем, для которого характерны темы войны, пацифизма, политики, взаимоотношений между людьми. Роман «Жизнь взаймы» стоит особняком от остальных книг Ремарка, потому что здесь автор сконцентрировался именно на психологии отношений, сделав все остальные события только фоном для любовной линии. Это история о любви молодой девушки по имени Лилиан и заядлого автогонщика Клерфэ.",
        age: "16+",
        genre: "Классическая проза",
        author: "Эрих Мария Ремарк",
        img: "/images/books/Жизнь взаймы.jpg",
        price: 545,
      },
      {
        id: "60",
        article: "60",
        title: "Земля обетованная",
        description:
          "Земля обетованная» — это одна из главных книг великого классика мировой литературы Эриха Марии Ремарка. Его произведения проникают в душу, заставляют задуматься, грустить и улыбаться. Этот роман был опубликован уже после смерти Ремарка, и в нем идет речь идет об американской мечте и ее крушении. Главные герои книги — эмигранты из Германии, которые бежали в Америку от ужасов фашистского режима. Они рассматривали Америку как оплот справедливости и свободы, но реальность, с которой им довелось столкнуться, не оправдала ожидания. Теперь каждый из них — сам за себя, и каждому предстоит пройти тернистый путь.",
        age: "16+",
        genre: "Зарубежная классика",
        author: "Эрих Мария Ремарк",
        img: "/images/books/Земля обетованная.jpg",
        price: 595,
      },
      {
        id: "61",
        article: "61",
        title: "Три товарища и другие романы",
        description:
          "Эрих Мария Ремарк – писатель, чье имя говорит само за себя, чья проза не подлежит старению. Для многих поколений читателей, выросших на его произведениях, для критиков, единодушно признавших его работы, он стал своеобразным символом времени.  Представленные в данном сборнике известнейшие романы Ремарка «Три товарища», «На Западном фронте без перемен» и «Триумфальная арка» доказывают, что верная дружба, истинное милосердие и любовь способны не только противостоять трагедиям Первой и Второй мировых войн, жестокому продажному миру, но и притупить боль представителей «потерянного поколения», наполнив их жизнь смыслом.",
        age: "16+",
        genre: "Литература 20 века",
        author: "Эрих Мария Ремарк",
        img: "/images/books/Три товарища и другие романы.jpg",
        price: 580,
      },
      {
        id: "62",
        article: "62",
        title: "Триумфальная арка / Arc de Triomphe",
        description:
          "Роман немецкого писателя Э.М. Ремарка «Триумфальная арка» рассказывает о судьбе и переживаниях талантливого немецкого врача. В Париже, где происходит основное действие романа, героя ждут новые испытания и знакомства. Для удобства читателей текст сопровождается комментариями и кратким словарем. Текст ориентирован на высокий уровень владения немецким языком.",
        age: "16+",
        genre: "Литература 20 века",
        author: "Эрих Мария Ремарк",
        img: "/images/books/Триумфальная арка.jpg",
        price: 625,
      },
      {
        id: "63",
        article: "63",
        title: "Приют Грез",
        description:
          "«Приют Грез» – первый роман Ремарка, который критики высмеяли за излишнюю сентиментальность и пафос. Однако это не помешало молодому автору стать впоследствии одним из величайших писателей. Германия 20-х годов XX века. Обитатели «Приюта Грез» – дома талантливого художника и композитора Фрица – далеки от трудностей реальной жизни. Сердца героев наполнены первой любовью и надеждами на прекрасное будущее. Но все меняется со смертью Фрица. Сумеют ли молодые люди пережить смерть своего друга и принять его отношение к жизни и искусству?",
        age: "16+",
        genre: "Литература 20 века",
        author: "Эрих Мария Ремарк",
        img: "/images/books/Приют Грез.jpg",
        price: 615,
      },
    ],
  },
  {
    author: "Томас Гарди",
    books: [
      {
        id: "64",
        article: "64",
        title: "В краю лесов",
        description:
          "Образованная девушка среднего класса должна выйти замуж за мужчину своего круга, уверен отец Грейс Мелбери. Равнодушный к чувствам дочери, он заставляет ее разорвать отношения с невежественным, но честным и добрым лесником Джайлсом Уинтерборном и буквально толкает под венец с доктором Эдридом Фитцпирсом. Однако семейная жизнь превращается в ад для обоих супругов: неисправимый женолюб Фитцпирс заводит интрижку за интрижкой, а Грейс, вовсе не склонная к кроткому долготерпению, изничтожает его колкостями и сарказмами.",
        age: "16+",
        genre: "Литература 19 века",
        author: "Томас Гарди",
        img: "/images/books/В краю лесов.jpg",
        price: 715,
      },
    ],
  },
  {
    author: "Джек Лондон",
    books: [
      {
        id: "65",
        article: "65",
        title: "Опасные маршруты",
        description:
          "Приглашаем в путешествие по самым опасным маршрутам на планете – на суше и на море. Постарайтесь не замерзнуть во льдах Северного полюса и не сойти с ума под палящим солнцем Африки. Вас ждут поиски древней гробницы, полной сокровищ, и погоня за пиратами в Карибском море. Вы побываете в необъятной русской тайге и в зыбучих песках Индии, проплывете на утлой лодке по великой реке Амазонке, уклоняясь от клыков, когтей и рогов диких зверей. А еще придется сражаться – с охотниками за скальпами, колдунами и кровожадными людоедами, а порой и с самим дьяволом. Вперед, на поиски приключений!",
        age: "12+",
        genre: "Книги о путешествиях",
        author: "Джек Лондон",
        img: "/images/books/Опасные маршруты.jpg",
        price: 335,
      },
    ],
  },
  {
    author: "Джеймс Оливер Кервуд",
    books: [
      {
        id: "66",
        article: "66",
        title: "Золотая петля",
        description:
          "«Брэм Джонсон был необыкновенным человеком даже для своего Севера. Не говоря уже ни о чем другом, он представлял собою продукт окружающей обстановки и крайней необходимости и еще чего-то такого, что делало из него то человека с душой, а то зверя с сердцем дьявола. В этой истории самого Брэма, девушки и еще одного человека к Брэму нельзя относиться слишком строго. Он был способен и на чувствительность и на жестокость. Впрочем, сомнительно, имел ли он то, что принято вообще считать душой. Если же и имел когда-нибудь, то она затерялась где-то в дремучих лесах и в той дикой обстановке, которая его окружала…»",
        age: "12+",
        genre: "Литература 20 века",
        author: "Джеймс Оливер Кервуд",
        img: "/images/books/Золотая петля.jpg",
        price: 435,
      },
      {
        id: "67",
        article: "67",
        title: "Погоня",
        description:
          "«Все казалось новым, а очень многое из этого нового – даже драматичным и страшным, – молодой женщине, сидевшей с низко опущенной на лицо серой вуалью. Вот уже восемнадцать часов, как она, широко раскрыв глаза от удивления и не без испуга, зорко приглядывалась к этому движению человеческой «орды». Она слышала, как всех этих пассажиров назвал «ордой» какой-то сидевший позади нее человек густым, грубым голосом, приглушенным бородой, о существовании которой она могла бы догадаться, даже и не посмотрев на этого пассажира. Это действительно была орда, та самая орда, которая всегда пробивает пути для цивилизации, идет впереди нее и составляет плоть и кровь будущей нации. Вот уже целые месяцы, как она настойчиво и упорно тянулась к этим горам, – все время вперед, никогда назад, – смеявшаяся, кричавшая, распевавшая и сквернословившая орда, каждый мускул которой был полон силы и каждое отдельное лицо которой было коричневым от загара. Только два падших ангела были не таковы. Один из них – черноглазая девушка с ярко накрашенными губами и нарумяненными щеками, сидела как раз напротив пассажирки в вуали. Дама в вуали продолжала слушать рассказ бородатого пассажира и его спутников, которые сидели позади нее…»",
        age: "12+",
        genre: "Зарубежная классика",
        author: "Джеймс Оливер Кервуд",
        img: "/images/books/Погоня.jpg",
        price: 415,
      },
      {
        id: "68",
        article: "68",
        title: "Казан",
        description:
          "Казан – дикая собака, в чьих жилах течёт ещё и кровь волка. Инстинкты разрывают его на части, заставляя мучительно выбирать между желанием служить людям и невероятной жаждой свободы, между ласковой рукой хозяйки и зовом Серой Волчицы, однажды избрав-шей его своим вожаком и повелителем. Претерпев множество лишений, столкнувшись с горем и жестокостью, Казан не утратит благородства и обретёт свой дом у Солнечной Скалы по велению самой природы, руководя-щей всеми живыми существами в мире.",
        age: "12+",
        genre: "Зарубежные приключения",
        author: "Джеймс Оливер Кервуд",
        img: "/images/books/Казан.jpg",
        price: 525,
      },
      {
        id: "69",
        article: "69",
        title: "Сын Казана",
        description:
          "«Когда Бари появился на свет, то некоторое время весь мир заключался для него только в одной мрачной берлоге. В первые дни его жизни его жилище находилось глубоко под валежником, где его слепая мать, Серая волчица, устроила для себя гнездо, чтобы произвести его на свет, и куда ее муж Казан заглядывал иногда, сверкая в темноте глазами, походившими на страшные зеленые огненные шарики. Именно эти глаза Казана дали Бари первое представление о том, что кроме его матери существовало на свете кое-что и еще, и именно благодаря им он открыл, что наконец прозрел. Он мог чувствовать, обонять, слышать, но, пока еще не открылись у него глаза, он ровно ничего не мог видеть под этой кучей свалившегося бурелома. Но вот сверкнули перед ним глаза его отца, в первую минуту испугали его, затем удивили, и, наконец, его страх перед ними перешел в безграничное любопытство. Он искал их даже и тогда, когда они потухали. Это было в те моменты, когда Казан отворачивал голову. Затем они вспыхивали вновь, и с такой неожиданностью, что он невольно прижимался к матери, которая всегда как-то странно пожималась и дрожала всякий раз, как входил к ней Казан…»",
        age: "12+",
        genre: "Зарубежные приключения",
        author: "Джеймс Оливер Кервуд",
        img: "/images/books/Сын Казана.jpg",
        price: 580,
      },
      {
        id: "70",
        article: "70",
        title: "Тяжелые годы",
        description:
          "Приключенческий роман Джеймса Кервуда повествует о войне Франции и Англии в Северной Америке во второй половине XVIII века. Юный Джимс Бюлэн возвращается домой и видит, что после нападения индейцев могауков все его родные убиты, а дом превращен в пепелище. Вместе со своей возлюбленной Туанеттой Тонтэр Джимс прячется в лесах. Вождь племени сенеков соглашается отвести их в таинственный город Ченуфсио, в который дикари приводят своих белых пленников. Но на пути героев ждет множество опасностей и испытаний.",
        age: "12+",
        genre: "Зарубежные приключения",
        author: "Джеймс Оливер Кервуд",
        img: "/images/books/Тяжелые годы.jpg",
        price: 570,
      },
      {
        id: "71",
        article: "71",
        title: "Чёрный Охотник",
        description:
          "Остросюжетный роман американского писателя Джеймса Оливера Кервуда, жившего и творившего на стыке столетий, как и многие из его произведений, посвящен Северной Канаде – краю необычайно красивому, но чрезвычайно опасному. Кервуд был весьма успешным писателем – в двадцатых годах прошлого столетия он был самым высокооплачиваемым автором в мире. Его произведения удачно продолжают традиции формата, предложенного Джеком Лондоном. Герои романа «Черный Охотник» – люди смелые, сильные характером, способные выйти из любой ситуации с честью. В книге читатель встретит все присущие приключенческому жанру черты: лихо закрученный сюжет, интриги, захватывающие дух описания природы северных земель.",
        age: "12+",
        genre: "Зарубежные приключения",
        author: "Джеймс Оливер Кервуд",
        img: "/images/books/Чёрный Охотник.jpg",
        price: 620,
      },
      {
        id: "72",
        article: "72",
        title: "Гризли",
        description:
          "Известный роман американского писателя Джеймса Оливера Кервуда о трогательной дружбе осиротевшего медвежонка Мусквы и огромного медведя Тэра. Книга продолжает мини-серию подарочных изданий о природе с иллюстрациями петербургского художника Владимира Канивца.",
        age: "6+",
        genre: "Зарубежные приключения",
        author: "Джеймс Оливер Кервуд",
        img: "/images/books/Гризли.jpg",
        price: 380,
      },
      {
        id: "73",
        article: "73",
        title: "Долина Молчаливых Призраков",
        description:
          "«Перед тем как стальные рельсы железной дороги врезались в Пустыню, единственным пунктом, через который можно было проникнуть в область приключений и в тайны великого снежного Севера, была пристань Атабаска. Даже до сих пор она так и называется на местном наречии – Искватам, то есть дверь, через которую только и можно проникнуть к нижнему течению рек Атабаски, Невольничьей и Макензи. Трудно найти на географической карте эту самую пристань Атабаску, хотя она там и должна была бы значиться, так как история этого места вписана в жизнь человечества более чем ста сорока годами трагедий, приключений и усилий и не так-то легко может забыться. Если ехать по старой дороге, то найдете ее милях в полутораста севернее Эдмонтона. Правда, железная дорога приблизила ее к этому крайнему пункту цивилизации, но по ту сторону этой северной границы цивилизации все еще властвует и показывает свою дикость Пустыня так же, как это было и тысячу лет тому назад; а воды рек целого материка все текут и текут по ней на Дальний Север, в Ледовитый океан…»",
        age: "12+",
        genre: "Зарубежная классика",
        author: "Джеймс Оливер Кервуд",
        img: "/images/books/Долина Молчаливых Призраков.jpg",
        price: 430,
      },
    ],
  },
  {
    author: "Оноре де Бальзак",
    books: [
      {
        id: "74",
        article: "74",
        title: "Шагреневая кожа",
        description:
          "В романе «Шагреневая кожа» Бальзак описал эту ситуацию с помощью выразительной метафоры: волшебный талисман исполняет все желания главного героя, но каждое исполненное желание укорачивает срок его жизни. Так же гибельна страсть художника к совершенству, описанная в рассказе «Неведомый шедевр».",
        age: "12+",
        genre: "Роман",
        author: "Оноре де Бальзак",
        img: "/images/books/Шагреневая кожа.jpg",
        price: 475,
      },
      {
        id: "75",
        article: "75",
        title: "Утраченные иллюзии",
        description:
          "Роман «Утраченные иллюзии» входит в масштабный литературный проект, которому автор дал название «Человеческая комедия». Бальзак желал создать точное описание жизни Франции, той, которая складывалась после революции. В части под названием «Этюды о нравах» Бальзак выделяет отдельную главу – «Сцены провинциальной жизни», куда и вошли «Утраченные иллюзии» наряду с романами «Евгения Гранде» и «Турский священник».",
        age: "12+",
        genre: "Роман",
        author: "Оноре де Бальзак",
        img: "/images/books/Утраченные иллюзии.jpg",
        price: 575,
      },
      {
        id: "76",
        article: "76",
        title: "Блеск и нищета куртизанок",
        description:
          "«Блеск и нищета куртизанок» – один из самых известных романов цикла «Человеческая комедия», посвященных тайной стороне жизни высшего парижского общества. Как обольстительны и коварны нравы парижского света, как жестоки и безжалостны его законы! Множество судеб, сплетенных интригами, жаждой славы, любовью, предательством в тугой узел, разрубить который оказывается способна лишь трагическая смерть красавицы куртизанки Эстер и Люсьена де Рюбампре – главных героев романа Бальзака.",
        age: "16+",
        genre: "Зарубежная классика",
        author: "Оноре де Бальзак",
        img: "/images/books/Блеск и нищета куртизанок.jpg",
        price: 585,
      },
      {
        id: "77",
        article: "77",
        title: "Гобсек",
        description:
          "«Гобсек» – повість французького письменника Оноре де Бальзака, надрукована в 1830 році, що відкриває епопею «Людська комедія» як частина «Сцен приватного життя». Основною темою повісті є влада грошей, а головним персонажем, навколо якого відбуваються всі дійства, є лихвар Гобсек.",
        age: "12+",
        genre: "Литература 19 века",
        author: "Оноре де Бальзак",
        img: "/images/books/Гобсек.jpg",
        price: 430,
      },
      {
        id: "78",
        article: "78",
        title: "Отец Горио",
        description:
          "«Отец Горио» – один из самых знаменитых романов Бальзака, вошедших в цикл «Человеческая комедия». Основные события романа происходят в Париже, в пансионе мадам Воке, запрятанном в нижней части улицы Нев-Сент-Женевьев, где за небольшую плату проживают малозаметные, потрепанные жизнью люди. На чердаке этого пансиона влачит свое жалкое существование главный герой романа папаша Горио – некогда преуспевающий торговец хлебом. Подобно королю Лиру он потратил почти все свое состояние на воспитание любимых дочерей. Обеспечив каждую богатым приданным, он оставил себе лишь небольшую сумму, в надежде на то, что всегда сможет найти у них любовь и поддержку. Но его надежды рассылались прахом. Удачно выйдя замуж и став светскими дамами, дочери стали стыдиться своего отца и вспоминали о нем лишь тогда, когда нуждались в деньгах. Постепенно Папаша Горио отдал им все, что у него было, и остался ни с чем. Он стал посмешищем всего пансиона, жильцы презирали его, и лишь один, бедный студент Эжен де Растиньяк, смотрел на старика с сочувствием…",
        age: "12+",
        genre: "Классическая проза",
        author: "Оноре де Бальзак",
        img: "/images/books/Отец Горио.jpg",
        price: 455,
      },
      {
        id: "79",
        article: "79",
        title: "Тёмное дело",
        description:
          "Действие романа «Темное дело» происходит в 1803–1806 годах; сцена в салоне княгини де Кадиньян, вписанная в эпилоге, относится к 1833 году. В основу сюжета произведения положен действительный исторический факт: похищение сенатора Клемана де Ри, имевшее место осенью 1800 года. Бальзак использует это происшествие для того, чтобы, как он сам пояснял в предисловии к роману, «изобразить политическую полицию в ее столкновении с частной жизнью, показать всю мерзость ее действий». Важное значение имеет изображенный в романе конфликт между заговорщиками-аристократами, сторонниками династии Бурбонов, и правительством Наполеона I.",
        age: "0+",
        genre: "Зарубежная классика",
        author: "Оноре де Бальзак",
        img: "/images/books/Тёмное дело.jpg",
        price: 485,
      },
      {
        id: "80",
        article: "80",
        title: "Сарразин",
        description:
          "Новелла Бальзака, относительно малоизвестная, а на самом деле одна из вершин его творчества.",
        age: "12+",
        genre: "Литература 19 века",
        author: "Оноре де Бальзак",
        img: "/images/books/Сарразин.jpg",
        price: 465,
      },
      {
        id: "81",
        article: "81",
        title: "Полковник Шабер",
        description:
          "Быть похороненным дважды и все равно остаться живым. Родиться в приюте для подкидышей, умереть в богадельне для престарелых, а в промежутке меж этими рубежами помогать Наполеону покорить Европу и Египет – что за судьба! судьба полковника Шабера.",
        age: "0+",
        genre: "Литература 19 века",
        author: "Оноре де Бальзак",
        img: "/images/books/Полковник Шабер.jpg",
        price: 365,
      },
      {
        id: "82",
        article: "82",
        title: "Беатриса",
        description:
          "В романе, показывая лживость и лицемерие «общественных деятелей» периода Июльской монархии, Бальзак подчеркивает, что скрытыми двигателями любой формы общественной деятельности в буржуазном обществе являются – наряду со стремлением извлечь изо всего выгоду – суетность, мелкое самолюбие и тщеславие.",
        age: "12+",
        genre: "Зарубежная классика",
        author: "Оноре де Бальзак",
        img: "/images/books/Беатриса.jpg",
        price: 385,
      },
      {
        id: "83",
        article: "83",
        title: "Мачеха",
        description:
          "Героиня драмы «Мачеха» Гертруда – женщина, которая ради денег пошла на компромисс с совестью и пожертвовала своей любовью ради материального благополучия.",
        age: "12+",
        genre: "Зарубежная классика",
        author: "Оноре де Бальзак",
        img: "/images/books/Мачеха.jpg",
        price: 285,
      },
      {
        id: "84",
        article: "84",
        title: "Проклятое дитя",
        description:
          "Действие повести перенесено Бальзаком в XVI век, в жестокую эпоху религиозных войн. Писатель не останавливается подробно на исторических событиях, однако суровые нравы эпохи феодального произвола и насилия показаны ярко и убедительно через трагическую судьбу жены и сына герцога д'Эрувиля, убитых страхом перед жестоким деспотом.",
        age: "12+",
        genre: "Литература 19 века",
        author: "Оноре де Бальзак",
        img: "/images/books/Проклятое дитя.jpg",
        price: 425,
      },
      {
        id: "85",
        article: "85",
        title: "Шуаны, или Бретань в 1799 году",
        description:
          "Действие «Шуанов» происходит в конце 1799 года. То были последние месяцы правления так называемой Директории и первые недели Консульства, возглавлявшегося Наполеоном Бонапартом. Власть в стране находилась в это время в руках крупной буржуазии, которая воспользовалась в своих интересах победой буржуазной революции во Франции. В основе романа лежит один из эпизодов борьбы республиканских войск с шуанами, во главе которых стояли дворяне-роялисты и католические священники. Восстание шуанов 1799 года в западных провинциях страны – Бретани и Вандее – было последней серьезной вспышкой роялистского мятежа, который охватил в 1793 году всю северо-западную Францию. Мятеж этот вдохновлялся из-за рубежа – из Англии, снабжавшей восставших оружием и деньгами.",
        age: "12+",
        genre: "Литература 19 века",
        author: "Оноре де Бальзак",
        img: "/images/books/Шуаны, или Бретань в 1799 году.jpg",
        price: 325,
      },
      {
        id: "86",
        article: "86",
        title: "Вотрен",
        description:
          "Пьеса посвящена разоблачению ложной, лицемерной аристократической морали. Автор наделяет Вотрена чертами, которые роднят его с героями романтических драм. Вотрен не лишен таинственности, он располагает большой властью, ибо у него в подчинении преступный мир, но эту власть он применяет для доброго дела: он всею душой предан своему воспитаннику – отвергнутому сыну герцога де Монсореля – и делает все возможное, чтобы он был счастлив. Ради него Вотрен жертвует и собственным благополучием.",
        age: "12+",
        genre: "Литература 19 века",
        author: "Оноре де Бальзак",
        img: "/images/books/Вотрен.jpg",
        price: 455,
      },
      {
        id: "87",
        article: "87",
        title: "Делец",
        description:
          "В комедии «Делец» изображается битва человека с кредиторами и уловки, к которым он прибегает, чтобы ускользнуть от них. С большой сатирической остротой изображает автор окружение Меркаде: темных дельцов, биржевых зайцев, ростовщиков, аферистов – словом, всю накипь буржуазного общества.",
        age: "12+",
        genre: "Зарубежная драматургия",
        author: "Оноре де Бальзак",
        img: "/images/books/Делец.jpg",
        price: 535,
      },
      {
        id: "88",
        article: "88",
        title: "Гамбара",
        description:
          "Безумный гений, музыкант Гамбара, одержим идеей преобразования самых основ музыки, он надеется создать музыку, в которой будут слышны голоса ангелов, а сама она будет построена по законам природы. Однако погоня за совершенством разрушает и искусство Гамбары, и его жизнь.",
        age: "12+",
        genre: "Литература 19 века",
        author: "Оноре де Бальзак",
        img: "/images/books/Гамбара.jpg",
        price: 515,
      },
      {
        id: "89",
        article: "89",
        title: "Неведомый шедевр",
        description:
          "«Эликсир долголетия». У смертного одра своего отца величайший из соблазнителей и циников Дон Жуан становится обладателем и хранителем великого и опасного магического артефакта… «Неведомый шедевр». Старый художник всю жизнь посвятил созданию одного-единственного шедевра – загадочного портрета, который он не показывает никогда и никому… «Поиски абсолюта». Знатный фламандец, одержимый тайнами познания, готов ради них на все: на расточительство, одиночество, разрыв с близкими и даже на преступление… «Прощенный Мельмот». Вот уже много веков странствует по миру бессмертный Мельмот-Скиталец. Кто же согласится принять его бессмертие, а с ним вместе и его проклятие? Перед вами четыре поразительные новеллы, входящие вместе с «Шагреневой кожей» в цикл «Философские этюды».",
        age: "12+",
        genre: "Зарубежная классика",
        author: "Оноре де Бальзак",
        img: "/images/books/Неведомый шедевр.jpg",
        price: 595,
      },
      {
        id: "90",
        article: "90",
        title: "Искусство и художник",
        description:
          "Литературный реализм создал не просто новый подход к искусству, но и умение работать не только с отдельными редкостями, а с образами и впечатлениями искусства, усматривая в искусстве все грани действительности. Оноре де Бальзак (1799–1850) решительно порвал с прежней эстетикой, видевшей в искусстве предмет любования и подражания, и раскрыл в искусстве опыты воображения и проницательного социального мышления. Разделение формы и содержания, произведенное Бальзаком, оказалось плодотворным для понимания миссии художника во всем драматизме карьеры. В настоящее издание включены высказывания Бальзака об искусстве, как опубликованные в виде отдельных статей, так и извлеченные из его романов. В предисловии профессора РГГУ Александра Маркова раскрываются философские и биографические предпосылки эстетики Бальзака.",
        age: "12+",
        genre: "Зарубежная классика",
        author: "Оноре де Бальзак",
        img: "/images/books/Искусство и художник.jpg",
        price: 385,
      },
      {
        id: "91",
        article: "91",
        title: "Памела Жиро",
        description:
          "В пьесе «Памела Жиро» противопоставлены, с одной стороны, искренняя любовь, бескорыстие, готовность пожертвовать собою ради любимого человека и алчность, тщеславие, погоня за богатым приданым, с другой стороны. Корыстные соображения в большей или меньшей степени руководят поступками всех выведенных в пьесе представителей буржуазии – родственников Жюля Руссо.",
        age: "12+",
        genre: "Зарубежная драматургия",
        author: "Оноре де Бальзак",
        img: "/images/books/Памела Жиро.jpg",
        price: 295,
      },
    ],
  },
];

export default books;
